import { render, staticRenderFns } from "./DropdownSidePanel.vue?vue&type=template&id=594da834&"
import script from "./DropdownSidePanel.vue?vue&type=script&lang=ts&"
export * from "./DropdownSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports